export const skillsStoreKey = 'skills';
